import { createFileRoute } from "@tanstack/react-router";
import { Master } from "@/components/Master";

function RouteComponent() {
  return <Master />;
}

export const Route = createFileRoute("/_authenticated/master/")({
  component: RouteComponent,
  staticData: { page: "finance" },
});
